import React, { Fragment } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import { SuperNav, SuperNavButton } from 'components/Layout/Header/components';
import CampaignMobileNav from 'components/Layout/Header/components/MobileNav/CampaignMobileNav';

import { HeaderI } from 'interfaces/content-stack/header';

import { headerMenuSpecialBehavior } from 'utils/constants';
import { getModularBlockLinkData } from 'utils/modularBlockUtils';

const CampaignHeader: React.FC = () => {
  const { contentstackHeader }: { contentstackHeader: HeaderI } = useStaticQuery(graphql`
    query {
      contentstackHeader {
        ...HeaderFragment
      }
    }
  `);
  const { superNav } = contentstackHeader;

  return (
    <>
      <SuperNav alertOpen={false} showLogo>
        {superNav?.menuItems?.map(({ linkText, link, specialBehavior }, i: number) => {
          const { link: linkUrl, target } = getModularBlockLinkData(link);

          if (specialBehavior === headerMenuSpecialBehavior.help) {
            return null;
          }

          return (
            <Fragment key={i}>
              <SuperNavButton text={linkText} specialBehavior={specialBehavior} link={linkUrl} target={target} />
            </Fragment>
          );
        })}
      </SuperNav>
      <CampaignMobileNav data={contentstackHeader?.mobileNav} />
    </>
  );
};

export default CampaignHeader;
